/** Unicode/text only: no image assets or persistent storage. */
export const HOME_PULL_LINES = [
  'Hold the bridge. Ignore the shouting.',
  'Keep a reserve. Expect bad dice.',
  'Small armies can make big waves.',
  'Your invasion permit is under review.',
  'Scattered dice with heavy reinforcements.',
  'Suspicious activity behind the snack tent.',
  'The reeds know what you did.',
  'Conquest postponed. Kettle still boiling.',
  'The carp refuses to comment.',
  'Confidence is cheaper than reinforcements.',
  'One border closer to breakfast.',
  'Refreshing won’t summon reinforcements.',
  'Pack light. Bring ridiculous courage.',
  'The map owes you nothing.',
  'Victory smells faintly of river mud.',
  'March quietly. The dice are sleeping.',
  'Every empire begins with wet boots.',
  'Check the bridge before declaring victory.',
  'Your reinforcements missed the bus.',
  'Fish first. Ask questions downstream.',
  'A patient general keeps dry socks.',
  'Today’s forecast: questionable border decisions.',
  'The quartermaster misplaced your ambition.',
  'Leave room for a clever retreat.',
  'There is dignity in regrouping.',
  'All hail the temporary front runner.',
  'The river remembers every shortcut.',
  'Forward, with appropriate paperwork.',
  'Try diplomacy. Keep the dice handy.',
  'This trench has excellent reception.',
  'We have requisitioned more optimism.',
  'Do not feed the enemy carp.',
  'A narrow crossing beats a grand speech.',
  'The flag is still over there.',
  'Patience is a renewable resource.',
  'Your grand strategy needs a snack.',
  'Fortify your position. Hydrate your general.',
  'The scout reports suspiciously peaceful ducks.',
  'Great plans survive small adjustments.',
  'The pond has entered negotiations.',
  'There is always another angle.',
  'Marching orders: mind the puddles.',
  'The enemy also has laundry.',
  'Heroes occasionally count their territories.',
  'Nothing conquers an empty lunchbox.',
  'Our battle anthem needs rehearsing.',
  'River patrol found your missing confidence.',
  'Every border is somebody’s bad idea.',
  'The generals have borrowed your pencil.',
  'Somewhere, a carp is plotting.',
  'You found the secret supply closet.',
  'Keep moving. Make sensible splashes.',
  'The war room is mostly biscuits.',
  'Bravery travels better with a plan.',
  'We deny all underwater allegations.',
  'Morale is up. Boots are damp.',
  'Your flanking maneuver has been approved.',
  'Maps are polite suggestions until Tuesday.',
  'The dice requested independent legal advice.',
  'A good reserve ruins enemy plans.',
  'No empire outgrows its supply lines.',
  'This briefing could have been a ripple.',
  'Approach victory with suspicious optimism.',
  'The carp union demands shorter turns.',
  'Beware unusually confident river stones.',
  'Orders received. Interpretation ongoing.',
  'Keep your friends near the bridge.',
  'Our spies are terrible at whispering.',
  'The flagpole filed a transfer request.',
  'Strategy improves after a decent breakfast.',
  'The pond council remains divided.',
  'Your courage has cleared customs.',
  'One good crossing changes the campaign.',
  'Nobody expects the administrative offensive.',
  'The secret tunnel leads to accounting.',
  'Roll boldly. Count carefully.',
  'A small foothold is still a foothold.',
  'The enemy’s kettle is also boiling.',
  'Your tactical pause looks very distinguished.',
  'Field report: the reeds are gossiping.',
  'Winning requires fewer speeches than expected.',
  'The amphibious division forgot its towels.',
  'Your next move deserves a second look.',
  'A retreat can be tomorrow’s invitation.',
  'Boots on. Doubts packed separately.',
  'The river is taking no sides.',
  'Formidable plans. Moderately formidable sandwiches.',
  'Your empire is buffering politely.',
  'The carp has noticed your persistence.',
  'Supply wagon approaching at heroic speed.',
  'Victory prefers generals who listen.',
  'The lookout spotted another lookout.',
  'Consider the quiet border.',
  'Some victories arrive in small boats.',
  'The war cabinet needs more chairs.',
  'Your camouflage fooled the quartermaster.',
  'Today we advance one sensible step.',
  'The battlefield has excellent birdwatching.',
  'Keep hope. Recheck the troop count.',
  'You have disturbed classified river business.',
] as const
export const HOME_PULL_EMOJIS = '🐟 🐠 🐡 🎣 🪖 ⚔️ 🛡️ 🏹 🗺️ 🧭 🏰 🚩 🏴 🏳️ ⛺ 🏕️ 🛶 ⛵ 🚤 ⚓ 🧱 🌉 🏔️ ⛰️ 🌋 🏜️ 🏝️ 🌲 🌳 🌴 🌿 🍃 🍂 🍄 🪵 🦆 🦉 🦅 🐦 🪿 🦎 🐢 🐊 🦀 🦞 🐙 🦑 🐚 🦈 🐬 🐳 🐋 🦭 🐸 🐌 🐞 🦗 🐝 🦋 🐜 🔥 💧 🌊 🌧️ ⛈️ 🌦️ ☀️ 🌙 ⭐ 🌌 🌀 🕳️ 🪐 ☄️ ⚡ 🪄 🎲 ♟️ 🧩 🎯 🏆 🥇 🥾 🧦 🎒 🧳 🔭 🔦 🕯️ 📜 📋 ✉️ 📬 🖋️ 🧮 ⚙️ 🔑 🫖 ☕ 🥪'.split(' ')
export type HomePullBackdrop = 'backstage' | 'matrix' | 'wormhole'
/** Every fifth pull swaps the grid for a rare scene, alternating through this cycle. */
export const HOME_PULL_RARE_EVERY = 5
export const HOME_PULL_RARE_CYCLE: readonly HomePullBackdrop[] = ['matrix', 'wormhole']
/**
 * In-memory only (resets on a fresh launch): the pull count plus the line and
 * emoji indices already shown, so nothing repeats until the catalog is used up.
 */
export interface HomePullSession { count: number; usedLines: readonly number[]; usedEmojis: readonly number[] }
export const EMPTY_HOME_PULL_SESSION: HomePullSession = { count: 0, usedLines: [], usedEmojis: [] }
export function homePullDistance(dragY: number) { return Number.isFinite(dragY) ? Math.max(0, dragY * 0.45) : 0 }

/*
 * The trigger: the pull-to-refresh gesture at the top of the home page. The
 * whole page (header included) slides down to uncover the secret above it,
 * and letting go past the refresh distance refreshes the lists.
 */
/** Touch/mouse drag down (px) while the list is at scroll offset 0 before the pull takes over. */
export const HOME_PULL_START_DRAG = 18
/** Revealed distance (px) that refreshes on release. */
export const HOME_PULL_REFRESH_DISTANCE = 72
/** Web wheel: scroll-up (px) past the top before the secret shows (about one mouse notch). */
export const HOME_WHEEL_START = 60
/** Web wheel: a pause this long (ms) starts a new gesture; only a gesture that starts at the top can pull. */
export const HOME_WHEEL_GAP_MS = 250
/** Web wheel: quiet this long (ms) counts as letting go. */
export const HOME_WHEEL_END_MS = 180
export const HOME_WHEEL_MAX = 700

/** A touch/mouse drag that should become the pull (rather than a scroll or a tap). */
export function startsHomePull({ atTop, dx, dy, touches }: { atTop: boolean; dx: number; dy: number; touches: number }) {
  return atTop && touches === 1 && dy > HOME_PULL_START_DRAG && Math.abs(dx) < dy / 2
}

/**
 * Web wheel/trackpad pull state. Wheel "scroll up" past the top accumulates as
 * a drag, but only for a gesture that began with the page already at the top,
 * so momentum from scrolling up a long list never sets it off.
 */
export interface HomeWheelPull { drag: number; held: boolean; fromTop: boolean; lastAt: number }
export const IDLE_HOME_WHEEL: HomeWheelPull = { drag: 0, held: false, fromTop: false, lastAt: -Infinity }

/** Pixels from a wheel event (line and page modes are scaled). */
export function wheelPixels(deltaY: number, deltaMode = 0) {
  if (!Number.isFinite(deltaY)) return 0
  return deltaY * (deltaMode === 1 ? 16 : deltaMode === 2 ? 400 : 1)
}

export function stepHomeWheel(state: HomeWheelPull, { deltaY, deltaMode = 0, at, atTop }: { deltaY: number; deltaMode?: number; at: number; atTop: boolean }): HomeWheelPull {
  const fresh = at - state.lastAt > HOME_WHEEL_GAP_MS
  const fromTop = state.held || (fresh ? atTop : state.fromTop && atTop)
  if (!fromTop) return { ...IDLE_HOME_WHEEL, lastAt: at }
  // Wheel up is a negative deltaY: that is the downward pull.
  const drag = Math.min(HOME_WHEEL_MAX, Math.max(0, state.drag - wheelPixels(deltaY, deltaMode)))
  const held = state.held ? drag > 0 : drag >= HOME_WHEEL_START
  return { drag, held, fromTop, lastAt: at }
}

/** Pick an index not in `used`; once every index has been shown the pool resets. */
function pickUnused(length: number, used: readonly number[], random: () => number) {
  const pool = used.length >= length ? [] : used
  const free: number[] = []
  for (let index = 0; index < length; index++) if (!pool.includes(index)) free.push(index)
  const index = free[Math.min(free.length - 1, Math.max(0, Math.floor(random() * free.length)))]!
  return { index, used: [...pool, index] }
}

export function chooseHomePull(session: HomePullSession, random = Math.random) {
  const count = session.count + 1
  const line = pickUnused(HOME_PULL_LINES.length, session.usedLines, random)
  const emoji = pickUnused(HOME_PULL_EMOJIS.length, session.usedEmojis, random)
  const rareTurn = count % HOME_PULL_RARE_EVERY === 0 ? count / HOME_PULL_RARE_EVERY : 0
  const backdrop: HomePullBackdrop = rareTurn ? HOME_PULL_RARE_CYCLE[(rareTurn - 1) % HOME_PULL_RARE_CYCLE.length]! : 'backstage'
  return { line: HOME_PULL_LINES[line.index]!, emoji: HOME_PULL_EMOJIS[emoji.index]!, backdrop,
    session: { count, usedLines: line.used, usedEmojis: emoji.used } }
}
